import React from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

interface AdminRouteProps {
  children: React.ReactNode
  allowedRoles?: string[]
}

// AdminRoute: Only allows super_admin, center_manager, and legacy admin roles
// Representatives are explicitly excluded
const AdminRoute: React.FC<AdminRouteProps> = ({ children, allowedRoles = ['super_admin', 'center_manager', 'admin'] }) => {
  const { session, loading, role } = useAuth()
  const navigate = useNavigate()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
      </div>
    )
  }

  if (!session?.user) {
    navigate('/auth')
    return null
  }

  // Explicitly block representatives and any other unauthorized roles
  if (!role || !allowedRoles.includes(role)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50 dark:bg-neutral-900">
        <div className="text-center">
          <div className="text-red-600 dark:text-red-400 text-lg font-semibold mb-2">
            Access Denied
          </div>
          <div className="text-neutral-600 dark:text-neutral-300">
            You don't have permission to access this page
          </div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}

export default AdminRoute
